import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material";
import {FormBuilder, FormControl, FormGroup, Validators} from "@angular/forms";
import {Service} from "../../../../classes/service";
import {kanServicesService} from "../../../services/services/services";

@Component({
    selector: 'kan-service-dialog',
    templateUrl: './component.html',
    styleUrls: ['./component.scss']
})
export class kanServiceDialog {
    public service: Service = new Service();
    public serviceTypes: string[] = ['USER', 'DOG'];
    public isNew: boolean = true;

    public serviceForm: FormGroup;

    constructor(private dialogRef: MatDialogRef<kanServiceDialog>,
                private formBuilder: FormBuilder,
                private servicesService: kanServicesService,
                @Inject(MAT_DIALOG_DATA) private data: any) {

        if (this.data && this.data.service) {
            this.service = JSON.parse(JSON.stringify(this.data.service));
            this.isNew = false;
        }
    }

    ngOnInit(): void {
        this.serviceForm = this.formBuilder.group({
            type: new FormControl(this.service.type, [Validators.required]),
            service: new FormControl(this.service.service, [Validators.required]),
            description: new FormControl(this.service.description),
            contract: new FormControl(this.service.contract)
        });
    }

    public addService(event: any) {

        this.servicesService.addService(this.service)
            .then((note) => {
                this.dialogRef.close('add');
            })
            .catch((error) => {
                console.log(error);
            });
    }

    public updateService(event: any) {

        this.servicesService.updateService(this.service)
            .then((note) => {
                this.dialogRef.close('update');
            })
            .catch((error) => {
                console.log(error);
            });
    }
}



// WEBPACK FOOTER //
// ./src/modules/admin/dialogs/service-dialog/component.ts